import React from 'react';
import { Description, DescriptionText } from './Description';

const ActionButtons = ({
  canApply = false,
  handleApply,
  disabledApply,
  canTemporarySave = false,
  handleTemporarySave,
  canRemove = false,
  handleRemove,
  canApplyCancel = false,
  handleApplyCancel,
  canReapply = false,
  handleReapply,
  canUpdate = false,
  handleUpdate,
}) => {
  return (
    <React.Fragment>
      {canApply && (
        <span className='construction-detail-view__button'>
          <button
            className={disabledApply ? 'btn--disabled' : 'btn--effective'}
            onClick={handleApply}
            disabled={disabledApply}
          >
            申請する
          </button>
        </span>
      )}
      {canTemporarySave && (
        <span className='construction-detail-view__button'>
          <button className='btn--effective' onClick={handleTemporarySave}>
            一時保存
          </button>
        </span>
      )}
      {canRemove && (
        <span className='construction-detail-view__button'>
          <button className='btn--negative' onClick={handleRemove}>
            削除
          </button>
        </span>
      )}
      {canApplyCancel && (
        <span className='construction-detail-view__button'>
          <button className='btn--negative' onClick={handleApplyCancel}>
            申請取り消し
          </button>
        </span>
      )}
      {canReapply && (
        <span className='construction-detail-view__button'>
          <button className='btn' onClick={handleReapply}>
            再申請
          </button>
        </span>
      )}
      {canUpdate && (
        <span className='construction-detail-view__button'>
          <button className='btn--effective' onClick={handleUpdate}>
            更新
          </button>
        </span>
      )}
      {disabledApply && (
        <span className='construction-detail-view__alert-text'>
          未入力項目があります
        </span>
      )}
    </React.Fragment>
  );
};

const RegisterHeader = ({
  canApply,
  handleApply,
  canTemporarySave,
  handleTemporarySave,
}) => {
  return (
    <div style={{ position: 'relative', padding: '5px 20px' }}>
      <div style={{ display: 'inline-block', padding: '5px 0' }}>
        <ActionButtons
          {...{
            canApply,
            handleApply,
            canTemporarySave,
            handleTemporarySave,
          }}
        />
      </div>
      <span style={{ display: 'inline-block', padding: '5px 0' }}>
        <Description style={{ display: 'inline-block', width: 'initial' }}>
          <DescriptionText textSize='small'>
            代行担当者や覚書の添付が空欄でも一時保存できるようになりました。申請の際には必須項目となります。
          </DescriptionText>
        </Description>
      </span>
    </div>
  );
};

const DetailHeader = ({
  canEdit,
  moveEditPage,
  canApply,
  handleApply,
  disabledApply,
  canTemporarySave,
  handleTemporarySave,
  canRemove,
  handleRemove,
  canApplyCancel,
  handleApplyCancel,
  canReapply,
  handleReapply,
}) => {
  return (
    <div className='contruction-detail-view__menu'>
      {canEdit && (
        <span className='construction-detail-view__button'>
          <button className='btn' onClick={moveEditPage}>
            編集
          </button>
        </span>
      )}
      <ActionButtons
        {...{
          canApply,
          handleApply,
          disabledApply,
          canTemporarySave,
          handleTemporarySave,
          canRemove,
          handleRemove,
          canApplyCancel,
          handleApplyCancel,
          canReapply,
          handleReapply,
        }}
      />
    </div>
  );
};

const EditHeader = ({
  handleFormClose,
  canApply,
  handleApply,
  canTemporarySave,
  handleTemporarySave,
  canRemove,
  handleRemove,
  canApplyCancel,
  handleApplyCancel,
  canReapply,
  handleReapply,
  canUpdate,
  handleUpdate,
}) => {
  return (
    <div className='contruction-detail-view__menu'>
      <span className='construction-detail-view__button'>
        <button className='btn--sub' onClick={handleFormClose}>
          編集をやめる
        </button>
      </span>
      <ActionButtons
        {...{
          canApply,
          handleApply,
          canTemporarySave,
          handleTemporarySave,
          canRemove,
          handleRemove,
          canApplyCancel,
          handleApplyCancel,
          canReapply,
          handleReapply,
          canUpdate,
          handleUpdate,
        }}
      />
    </div>
  );
};

export { RegisterHeader, DetailHeader, EditHeader };



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationHeader.jsx